var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-title',[_vm._v("กราฟแท่งแสดงข้อมูลเคสย้อนหลัง 12 เดือน โดยแสดงอัตราส่วนสถานะของเคสระหว่างที่ปิดแล้วกับที่ยังปิด และกราฟเส้น ที่แสดง % ในแต่ละเดือน")]),_c('StackedColumnChart',{attrs:{"isMock":false,"data":_vm.items,"categoryField":"title","valueText":"จำนวนเคส","percentLineValueField":"percentage","percentLineText":"% Success Rate","valueFields":[
    { key: 'closed', name: 'ปิดแล้ว' },
    { key: 'open', name: 'ที่ยังปิดไม่ได้' }]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }